import React, { createContext, useContext, useState, useEffect } from "react";

// Create Sidebar Context
const SidebarContext = createContext();

// Custom hook for consuming the context
export const useSidebar = () => useContext(SidebarContext);

// Sidebar Provider to wrap the app
export const SidebarProvider = ({ children }) => {
  // Check for the saved state in localStorage or set default to false (collapsed)
  const storedState = localStorage.getItem("isSidebarExpanded");

  // Initialize state based on stored value or default value
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(
    storedState === null ? false : JSON.parse(storedState)
  );

  // Toggle Sidebar function
  const toggleSidebar = () => {
    const newState = !isSidebarExpanded;
    setIsSidebarExpanded(newState);

    // Store the new state in localStorage
    localStorage.setItem("isSidebarExpanded", JSON.stringify(newState));
  };

  // Effect to update the state when page reloads (optional)
  useEffect(() => {
    // Ensure state is synced with localStorage if necessary
    if (storedState !== null) {
      setIsSidebarExpanded(JSON.parse(storedState));
    }
  }, [storedState]);

  return (
    <SidebarContext.Provider value={{ isSidebarExpanded, toggleSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
};
